import React from "react";
import Translate from "../../../localization/Translate";
import {addErrorAlert, showInputDialogue} from "../../../redux/actions";
import {useDispatch} from "react-redux";

let displayEnterAmountDialogue = (dispatch, maxAmount) => {
    return new Promise((resolve, reject) => {
        dispatch(showInputDialogue('Enter amount', '', '', (inputAmount) => {
            if(inputAmount.indexOf(',') !== -1 || inputAmount.indexOf('.') !== -1){
                dispatch(addErrorAlert('Please enter a full number'));
                return;
            }
            let parsedInput = parseInt(inputAmount.replace(',', '.'));
            if(isNaN(parsedInput)){
                dispatch(addErrorAlert('Please enter a number'));
            }else{
                if(parsedInput === 0){
                    dispatch(addErrorAlert('Quantity can\'t be 0'));
                    return;
                }
                if(parsedInput > maxAmount){
                    dispatch(addErrorAlert('Quantity can\'t be higher than on the sale!'));
                    return;
                }
                resolve(parsedInput);
            }
        }, reject, true, true, 'zIndex6'));
    });
}
export default function ({item, onCheckToggle, onChangeReturnAmount}) {
    const dispatch = useDispatch();
    return (
        <tr className={"productLine"}>
            <td>
                <input type={"checkbox"} readOnly={"readonly"} checked={item.checked} onClick={(e) => {
                    onCheckToggle(!item.checked, e);
                }}/>
            </td>
            <td>
                {item.product.itemName}
                <br/>
                {
                    item.product.typeOfArticle ?
                        <><Translate id={"Type of article"}/>: {item.product.typeOfArticle}</>
                        :
                        ''
                }
            </td>
            <td>
                {item.product.code}
            </td>
            <td>
                {item.product.amount}
            </td>
            <td onClick={() => {
                displayEnterAmountDialogue(dispatch, item.product.amount).then((newAmount) => {
                    onChangeReturnAmount(newAmount);
                }, () => {});
            }}>
                {item.product.returnAmount ?? item.product.amount}
            </td>
            <td>
                {item.product.rowTotal}
            </td>
        </tr>
    );
}
